/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Badge,
  Button,
  Divider,
  Flex,
  Grid,
  Icon,
  ScrollView,
  SelectField,
  Text,
  TextField,
  useTheme,
} from "@aws-amplify/ui-react";
import { getOverrideProps } from "@aws-amplify/ui-react/internal";
import { VehicleModelGeneralInfo } from "../models";
import { fetchByPath, validateField } from "./utils";
import { DataStore } from "aws-amplify";
function ArrayField({
  items = [],
  onChange,
  label,
  inputFieldRef,
  children,
  hasError,
  setFieldValue,
  currentFieldValue,
  defaultFieldValue,
  lengthLimit,
  getBadgeText,
  runValidationTasks,
  errorMessage,
}) {
  const labelElement = <Text>{label}</Text>;
  const {
    tokens: {
      components: {
        fieldmessages: { error: errorStyles },
      },
    },
  } = useTheme();
  const [selectedBadgeIndex, setSelectedBadgeIndex] = React.useState();
  const [isEditing, setIsEditing] = React.useState();
  React.useEffect(() => {
    if (isEditing) {
      inputFieldRef?.current?.focus();
    }
  }, [isEditing]);
  const removeItem = async (removeIndex) => {
    const newItems = items.filter((value, index) => index !== removeIndex);
    await onChange(newItems);
    setSelectedBadgeIndex(undefined);
  };
  const addItem = async () => {
    const { hasError } = runValidationTasks();
    if (
      currentFieldValue !== undefined &&
      currentFieldValue !== null &&
      currentFieldValue !== "" &&
      !hasError
    ) {
      const newItems = [...items];
      if (selectedBadgeIndex !== undefined) {
        newItems[selectedBadgeIndex] = currentFieldValue;
        setSelectedBadgeIndex(undefined);
      } else {
        newItems.push(currentFieldValue);
      }
      await onChange(newItems);
      setIsEditing(false);
    }
  };
  const arraySection = (
    <React.Fragment>
      {!!items?.length && (
        <ScrollView height="inherit" width="inherit" maxHeight={"7rem"}>
          {items.map((value, index) => {
            return (
              <Badge
                key={index}
                style={{
                  cursor: "pointer",
                  alignItems: "center",
                  marginRight: 3,
                  marginTop: 3,
                  backgroundColor:
                    index === selectedBadgeIndex ? "#B8CEF9" : "",
                }}
                onClick={() => {
                  setSelectedBadgeIndex(index);
                  setFieldValue(items[index]);
                  setIsEditing(true);
                }}
              >
                {getBadgeText ? getBadgeText(value) : value.toString()}
                <Icon
                  style={{
                    cursor: "pointer",
                    paddingLeft: 3,
                    width: 20,
                    height: 20,
                  }}
                  viewBox={{ width: 20, height: 20 }}
                  paths={[
                    {
                      d: "M10 10l5.09-5.09L10 10l5.09 5.09L10 10zm0 0L4.91 4.91 10 10l-5.09 5.09L10 10z",
                      stroke: "black",
                    },
                  ]}
                  ariaLabel="button"
                  onClick={(event) => {
                    event.stopPropagation();
                    removeItem(index);
                  }}
                />
              </Badge>
            );
          })}
        </ScrollView>
      )}
      <Divider orientation="horizontal" marginTop={5} />
    </React.Fragment>
  );
  if (lengthLimit !== undefined && items.length >= lengthLimit && !isEditing) {
    return (
      <React.Fragment>
        {labelElement}
        {arraySection}
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      {labelElement}
      {isEditing && children}
      {!isEditing ? (
        <>
          <Button
            onClick={() => {
              setIsEditing(true);
            }}
          >
            Add item
          </Button>
          {errorMessage && hasError && (
            <Text color={errorStyles.color} fontSize={errorStyles.fontSize}>
              {errorMessage}
            </Text>
          )}
        </>
      ) : (
        <Flex justifyContent="flex-end">
          {(currentFieldValue || isEditing) && (
            <Button
              children="Cancel"
              type="button"
              size="small"
              onClick={() => {
                setFieldValue(defaultFieldValue);
                setIsEditing(false);
                setSelectedBadgeIndex(undefined);
              }}
            ></Button>
          )}
          <Button size="small" variation="link" onClick={addItem}>
            {selectedBadgeIndex !== undefined ? "Save" : "Add"}
          </Button>
        </Flex>
      )}
      {arraySection}
    </React.Fragment>
  );
}
export default function VehicleModelGeneralInfoCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    Manufacturer: "",
    ModelName: "",
    ModelYear: "",
    VehicleType: "",
    BodyStyle: "",
    EngineType: "",
    EnginePower: "",
    FuelType: "",
    Transmission: "",
    Drivetrain: "",
    Acceleration: "",
    TopSpeed: "",
    FuelEconomy: "",
    InteriorFeatures: [],
    ExteriorFeatures: [],
    SafetyFeatures: [],
    DriverAssistFeatures: [],
    CargoSpace: "",
    SeatingCapacity: "",
    TireSize: "",
    Dimensions: "",
    Wheelbase: "",
    Weight: "",
    SuspensionType: "",
    BrakingSystem: "",
    ColorOptions: [],
    Price: "",
    Warranty: "",
    EntertainmentSystem: [],
    ConnectivityFeatures: [],
    Aerodynamics: "",
    PerformancePackages: [],
    Certifications: [],
    CountryOfOrigin: "",
    CompetingModels: [],
    Information: "",
    Picture: "",
    Make: "",
  };
  const [Manufacturer, setManufacturer] = React.useState(
    initialValues.Manufacturer
  );
  const [ModelName, setModelName] = React.useState(initialValues.ModelName);
  const [ModelYear, setModelYear] = React.useState(initialValues.ModelYear);
  const [VehicleType, setVehicleType] = React.useState(
    initialValues.VehicleType
  );
  const [BodyStyle, setBodyStyle] = React.useState(initialValues.BodyStyle);
  const [EngineType, setEngineType] = React.useState(initialValues.EngineType);
  const [EnginePower, setEnginePower] = React.useState(
    initialValues.EnginePower
  );
  const [FuelType, setFuelType] = React.useState(initialValues.FuelType);
  const [Transmission, setTransmission] = React.useState(
    initialValues.Transmission
  );
  const [Drivetrain, setDrivetrain] = React.useState(initialValues.Drivetrain);
  const [Acceleration, setAcceleration] = React.useState(
    initialValues.Acceleration
  );
  const [TopSpeed, setTopSpeed] = React.useState(initialValues.TopSpeed);
  const [FuelEconomy, setFuelEconomy] = React.useState(
    initialValues.FuelEconomy
  );
  const [InteriorFeatures, setInteriorFeatures] = React.useState(
    initialValues.InteriorFeatures
  );
  const [ExteriorFeatures, setExteriorFeatures] = React.useState(
    initialValues.ExteriorFeatures
  );
  const [SafetyFeatures, setSafetyFeatures] = React.useState(
    initialValues.SafetyFeatures
  );
  const [DriverAssistFeatures, setDriverAssistFeatures] = React.useState(
    initialValues.DriverAssistFeatures
  );
  const [CargoSpace, setCargoSpace] = React.useState(initialValues.CargoSpace);
  const [SeatingCapacity, setSeatingCapacity] = React.useState(
    initialValues.SeatingCapacity
  );
  const [TireSize, setTireSize] = React.useState(initialValues.TireSize);
  const [Dimensions, setDimensions] = React.useState(initialValues.Dimensions);
  const [Wheelbase, setWheelbase] = React.useState(initialValues.Wheelbase);
  const [Weight, setWeight] = React.useState(initialValues.Weight);
  const [SuspensionType, setSuspensionType] = React.useState(
    initialValues.SuspensionType
  );
  const [BrakingSystem, setBrakingSystem] = React.useState(
    initialValues.BrakingSystem
  );
  const [ColorOptions, setColorOptions] = React.useState(
    initialValues.ColorOptions
  );
  const [Price, setPrice] = React.useState(initialValues.Price);
  const [Warranty, setWarranty] = React.useState(initialValues.Warranty);
  const [EntertainmentSystem, setEntertainmentSystem] = React.useState(
    initialValues.EntertainmentSystem
  );
  const [ConnectivityFeatures, setConnectivityFeatures] = React.useState(
    initialValues.ConnectivityFeatures
  );
  const [Aerodynamics, setAerodynamics] = React.useState(
    initialValues.Aerodynamics
  );
  const [PerformancePackages, setPerformancePackages] = React.useState(
    initialValues.PerformancePackages
  );
  const [Certifications, setCertifications] = React.useState(
    initialValues.Certifications
  );
  const [CountryOfOrigin, setCountryOfOrigin] = React.useState(
    initialValues.CountryOfOrigin
  );
  const [CompetingModels, setCompetingModels] = React.useState(
    initialValues.CompetingModels
  );
  const [Information, setInformation] = React.useState(
    initialValues.Information
  );
  const [Picture, setPicture] = React.useState(initialValues.Picture);
  const [Make, setMake] = React.useState(initialValues.Make);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setManufacturer(initialValues.Manufacturer);
    setModelName(initialValues.ModelName);
    setModelYear(initialValues.ModelYear);
    setVehicleType(initialValues.VehicleType);
    setBodyStyle(initialValues.BodyStyle);
    setEngineType(initialValues.EngineType);
    setEnginePower(initialValues.EnginePower);
    setFuelType(initialValues.FuelType);
    setTransmission(initialValues.Transmission);
    setDrivetrain(initialValues.Drivetrain);
    setAcceleration(initialValues.Acceleration);
    setTopSpeed(initialValues.TopSpeed);
    setFuelEconomy(initialValues.FuelEconomy);
    setInteriorFeatures(initialValues.InteriorFeatures);
    setCurrentInteriorFeaturesValue("");
    setExteriorFeatures(initialValues.ExteriorFeatures);
    setCurrentExteriorFeaturesValue("");
    setSafetyFeatures(initialValues.SafetyFeatures);
    setCurrentSafetyFeaturesValue("");
    setDriverAssistFeatures(initialValues.DriverAssistFeatures);
    setCurrentDriverAssistFeaturesValue("");
    setCargoSpace(initialValues.CargoSpace);
    setSeatingCapacity(initialValues.SeatingCapacity);
    setTireSize(initialValues.TireSize);
    setDimensions(initialValues.Dimensions);
    setWheelbase(initialValues.Wheelbase);
    setWeight(initialValues.Weight);
    setSuspensionType(initialValues.SuspensionType);
    setBrakingSystem(initialValues.BrakingSystem);
    setColorOptions(initialValues.ColorOptions);
    setCurrentColorOptionsValue("");
    setPrice(initialValues.Price);
    setWarranty(initialValues.Warranty);
    setEntertainmentSystem(initialValues.EntertainmentSystem);
    setCurrentEntertainmentSystemValue("");
    setConnectivityFeatures(initialValues.ConnectivityFeatures);
    setCurrentConnectivityFeaturesValue("");
    setAerodynamics(initialValues.Aerodynamics);
    setPerformancePackages(initialValues.PerformancePackages);
    setCurrentPerformancePackagesValue("");
    setCertifications(initialValues.Certifications);
    setCurrentCertificationsValue("");
    setCountryOfOrigin(initialValues.CountryOfOrigin);
    setCompetingModels(initialValues.CompetingModels);
    setCurrentCompetingModelsValue("");
    setInformation(initialValues.Information);
    setPicture(initialValues.Picture);
    setMake(initialValues.Make);
    setErrors({});
  };
  const [currentInteriorFeaturesValue, setCurrentInteriorFeaturesValue] =
    React.useState("");
  const InteriorFeaturesRef = React.createRef();
  const [currentExteriorFeaturesValue, setCurrentExteriorFeaturesValue] =
    React.useState("");
  const ExteriorFeaturesRef = React.createRef();
  const [currentSafetyFeaturesValue, setCurrentSafetyFeaturesValue] =
    React.useState("");
  const SafetyFeaturesRef = React.createRef();
  const [
    currentDriverAssistFeaturesValue,
    setCurrentDriverAssistFeaturesValue,
  ] = React.useState("");
  const DriverAssistFeaturesRef = React.createRef();
  const [currentColorOptionsValue, setCurrentColorOptionsValue] =
    React.useState("");
  const ColorOptionsRef = React.createRef();
  const [currentEntertainmentSystemValue, setCurrentEntertainmentSystemValue] =
    React.useState("");
  const EntertainmentSystemRef = React.createRef();
  const [
    currentConnectivityFeaturesValue,
    setCurrentConnectivityFeaturesValue,
  ] = React.useState("");
  const ConnectivityFeaturesRef = React.createRef();
  const [currentPerformancePackagesValue, setCurrentPerformancePackagesValue] =
    React.useState("");
  const PerformancePackagesRef = React.createRef();
  const [currentCertificationsValue, setCurrentCertificationsValue] =
    React.useState("");
  const CertificationsRef = React.createRef();
  const [currentCompetingModelsValue, setCurrentCompetingModelsValue] =
    React.useState("");
  const CompetingModelsRef = React.createRef();
  const validations = {
    Manufacturer: [{ type: "Required" }],
    ModelName: [{ type: "Required" }],
    ModelYear: [{ type: "Required" }],
    VehicleType: [{ type: "Required" }],
    BodyStyle: [{ type: "Required" }],
    EngineType: [],
    EnginePower: [],
    FuelType: [],
    Transmission: [],
    Drivetrain: [],
    Acceleration: [],
    TopSpeed: [],
    FuelEconomy: [],
    InteriorFeatures: [],
    ExteriorFeatures: [],
    SafetyFeatures: [],
    DriverAssistFeatures: [],
    CargoSpace: [],
    SeatingCapacity: [{ type: "Required" }],
    TireSize: [],
    Dimensions: [],
    Wheelbase: [],
    Weight: [],
    SuspensionType: [],
    BrakingSystem: [],
    ColorOptions: [],
    Price: [],
    Warranty: [],
    EntertainmentSystem: [],
    ConnectivityFeatures: [],
    Aerodynamics: [],
    PerformancePackages: [],
    Certifications: [],
    CountryOfOrigin: [],
    CompetingModels: [],
    Information: [],
    Picture: [{ type: "URL" }],
    Make: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          Manufacturer,
          ModelName,
          ModelYear,
          VehicleType,
          BodyStyle,
          EngineType,
          EnginePower,
          FuelType,
          Transmission,
          Drivetrain,
          Acceleration,
          TopSpeed,
          FuelEconomy,
          InteriorFeatures,
          ExteriorFeatures,
          SafetyFeatures,
          DriverAssistFeatures,
          CargoSpace,
          SeatingCapacity,
          TireSize,
          Dimensions,
          Wheelbase,
          Weight,
          SuspensionType,
          BrakingSystem,
          ColorOptions,
          Price,
          Warranty,
          EntertainmentSystem,
          ConnectivityFeatures,
          Aerodynamics,
          PerformancePackages,
          Certifications,
          CountryOfOrigin,
          CompetingModels,
          Information,
          Picture,
          Make,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          const modelFieldsToSave = {
            Manufacturer: modelFields.Manufacturer,
            ModelName: modelFields.ModelName,
            ModelYear: modelFields.ModelYear,
            VehicleType: modelFields.VehicleType,
            BodyStyle: modelFields.BodyStyle,
            EngineType: modelFields.EngineType,
            EnginePower: modelFields.EnginePower,
            FuelType: modelFields.FuelType,
            Transmission: modelFields.Transmission,
            Drivetrain: modelFields.Drivetrain,
            Acceleration: modelFields.Acceleration,
            TopSpeed: modelFields.TopSpeed,
            FuelEconomy: modelFields.FuelEconomy,
            InteriorFeatures: modelFields.InteriorFeatures,
            ExteriorFeatures: modelFields.ExteriorFeatures,
            SafetyFeatures: modelFields.SafetyFeatures,
            DriverAssistFeatures: modelFields.DriverAssistFeatures,
            CargoSpace: modelFields.CargoSpace,
            SeatingCapacity: modelFields.SeatingCapacity,
            TireSize: modelFields.TireSize,
            Dimensions: modelFields.Dimensions,
            Wheelbase: modelFields.Wheelbase,
            Weight: modelFields.Weight,
            SuspensionType: modelFields.SuspensionType,
            BrakingSystem: modelFields.BrakingSystem,
            ColorOptions: modelFields.ColorOptions,
            Price: modelFields.Price,
            Warranty: modelFields.Warranty,
            EntertainmentSystem: modelFields.EntertainmentSystem,
            ConnectivityFeatures: modelFields.ConnectivityFeatures,
            Aerodynamics: modelFields.Aerodynamics,
            PerformancePackages: modelFields.PerformancePackages,
            Certifications: modelFields.Certifications,
            CountryOfOrigin: modelFields.CountryOfOrigin,
            CompetingModels: modelFields.CompetingModels,
            Information: modelFields.Information,
            Picture: modelFields.Picture,
          };
          await DataStore.save(new VehicleModelGeneralInfo(modelFieldsToSave));
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "VehicleModelGeneralInfoCreateForm")}
      {...rest}
    >
      <TextField
        label="Manufacturer"
        isRequired={true}
        isReadOnly={false}
        value={Manufacturer}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Manufacturer: value,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            value = result?.Manufacturer ?? value;
          }
          if (errors.Manufacturer?.hasError) {
            runValidationTasks("Manufacturer", value);
          }
          setManufacturer(value);
        }}
        onBlur={() => runValidationTasks("Manufacturer", Manufacturer)}
        errorMessage={errors.Manufacturer?.errorMessage}
        hasError={errors.Manufacturer?.hasError}
        {...getOverrideProps(overrides, "Manufacturer")}
      ></TextField>
      <TextField
        label="Model name"
        isRequired={true}
        isReadOnly={false}
        value={ModelName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName: value,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            value = result?.ModelName ?? value;
          }
          if (errors.ModelName?.hasError) {
            runValidationTasks("ModelName", value);
          }
          setModelName(value);
        }}
        onBlur={() => runValidationTasks("ModelName", ModelName)}
        errorMessage={errors.ModelName?.errorMessage}
        hasError={errors.ModelName?.hasError}
        {...getOverrideProps(overrides, "ModelName")}
      ></TextField>
      <TextField
        label="Model year"
        isRequired={true}
        isReadOnly={false}
        type="number"
        step="any"
        value={ModelYear}
        onChange={(e) => {
          let value = isNaN(parseInt(e.target.value))
            ? e.target.value
            : parseInt(e.target.value);
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear: value,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            value = result?.ModelYear ?? value;
          }
          if (errors.ModelYear?.hasError) {
            runValidationTasks("ModelYear", value);
          }
          setModelYear(value);
        }}
        onBlur={() => runValidationTasks("ModelYear", ModelYear)}
        errorMessage={errors.ModelYear?.errorMessage}
        hasError={errors.ModelYear?.hasError}
        {...getOverrideProps(overrides, "ModelYear")}
      ></TextField>
      <SelectField
        label="Vehicle type"
        placeholder="Please select an option"
        isDisabled={false}
        value={VehicleType}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType: value,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            value = result?.VehicleType ?? value;
          }
          if (errors.VehicleType?.hasError) {
            runValidationTasks("VehicleType", value);
          }
          setVehicleType(value);
        }}
        onBlur={() => runValidationTasks("VehicleType", VehicleType)}
        errorMessage={errors.VehicleType?.errorMessage}
        hasError={errors.VehicleType?.hasError}
        {...getOverrideProps(overrides, "VehicleType")}
      >
        <option
          children="Car"
          value="CAR"
          {...getOverrideProps(overrides, "VehicleTypeoption0")}
        ></option>
        <option
          children="Motorcycle"
          value="MOTORCYCLE"
          {...getOverrideProps(overrides, "VehicleTypeoption1")}
        ></option>
        <option
          children="Truck"
          value="TRUCK"
          {...getOverrideProps(overrides, "VehicleTypeoption2")}
        ></option>
        <option
          children="Plane"
          value="PLANE"
          {...getOverrideProps(overrides, "VehicleTypeoption3")}
        ></option>
        <option
          children="Train"
          value="TRAIN"
          {...getOverrideProps(overrides, "VehicleTypeoption4")}
        ></option>
        <option
          children="Ship"
          value="SHIP"
          {...getOverrideProps(overrides, "VehicleTypeoption5")}
        ></option>
      </SelectField>
      <SelectField
        label="Body style"
        placeholder="Please select an option"
        isDisabled={false}
        value={BodyStyle}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle: value,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            value = result?.BodyStyle ?? value;
          }
          if (errors.BodyStyle?.hasError) {
            runValidationTasks("BodyStyle", value);
          }
          setBodyStyle(value);
        }}
        onBlur={() => runValidationTasks("BodyStyle", BodyStyle)}
        errorMessage={errors.BodyStyle?.errorMessage}
        hasError={errors.BodyStyle?.hasError}
        {...getOverrideProps(overrides, "BodyStyle")}
      >
        <option
          children="Compact"
          value="COMPACT"
          {...getOverrideProps(overrides, "BodyStyleoption0")}
        ></option>
        <option
          children="Sedan"
          value="SEDAN"
          {...getOverrideProps(overrides, "BodyStyleoption1")}
        ></option>
        <option
          children="Hatchback"
          value="HATCHBACK"
          {...getOverrideProps(overrides, "BodyStyleoption2")}
        ></option>
        <option
          children="Pickup truck"
          value="PICKUP_TRUCK"
          {...getOverrideProps(overrides, "BodyStyleoption3")}
        ></option>
        <option
          children="Suv"
          value="SUV"
          {...getOverrideProps(overrides, "BodyStyleoption4")}
        ></option>
        <option
          children="Sports"
          value="SPORTS"
          {...getOverrideProps(overrides, "BodyStyleoption5")}
        ></option>
        <option
          children="Cruiser"
          value="CRUISER"
          {...getOverrideProps(overrides, "BodyStyleoption6")}
        ></option>
        <option
          children="Sportbike"
          value="SPORTBIKE"
          {...getOverrideProps(overrides, "BodyStyleoption7")}
        ></option>
        <option
          children="Semi"
          value="SEMI"
          {...getOverrideProps(overrides, "BodyStyleoption8")}
        ></option>
        <option
          children="Freight"
          value="FREIGHT"
          {...getOverrideProps(overrides, "BodyStyleoption9")}
        ></option>
        <option
          children="Passenger"
          value="PASSENGER"
          {...getOverrideProps(overrides, "BodyStyleoption10")}
        ></option>
        <option
          children="Cargo"
          value="CARGO"
          {...getOverrideProps(overrides, "BodyStyleoption11")}
        ></option>
        <option
          children="Jet"
          value="JET"
          {...getOverrideProps(overrides, "BodyStyleoption12")}
        ></option>
        <option
          children="Commercial"
          value="COMMERCIAL"
          {...getOverrideProps(overrides, "BodyStyleoption13")}
        ></option>
        <option
          children="Cargo ship"
          value="CARGO_SHIP"
          {...getOverrideProps(overrides, "BodyStyleoption14")}
        ></option>
        <option
          children="Yacht"
          value="YACHT"
          {...getOverrideProps(overrides, "BodyStyleoption15")}
        ></option>
        <option
          children="Other"
          value="OTHER"
          {...getOverrideProps(overrides, "BodyStyleoption16")}
        ></option>
      </SelectField>
      <TextField
        label="Engine type"
        isRequired={false}
        isReadOnly={false}
        value={EngineType}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType: value,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            value = result?.EngineType ?? value;
          }
          if (errors.EngineType?.hasError) {
            runValidationTasks("EngineType", value);
          }
          setEngineType(value);
        }}
        onBlur={() => runValidationTasks("EngineType", EngineType)}
        errorMessage={errors.EngineType?.errorMessage}
        hasError={errors.EngineType?.hasError}
        {...getOverrideProps(overrides, "EngineType")}
      ></TextField>
      <TextField
        label="Engine power"
        isRequired={false}
        isReadOnly={false}
        value={EnginePower}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower: value,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            value = result?.EnginePower ?? value;
          }
          if (errors.EnginePower?.hasError) {
            runValidationTasks("EnginePower", value);
          }
          setEnginePower(value);
        }}
        onBlur={() => runValidationTasks("EnginePower", EnginePower)}
        errorMessage={errors.EnginePower?.errorMessage}
        hasError={errors.EnginePower?.hasError}
        {...getOverrideProps(overrides, "EnginePower")}
      ></TextField>
      <SelectField
        label="Fuel type"
        placeholder="Please select an option"
        isDisabled={false}
        value={FuelType}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType: value,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            value = result?.FuelType ?? value;
          }
          if (errors.FuelType?.hasError) {
            runValidationTasks("FuelType", value);
          }
          setFuelType(value);
        }}
        onBlur={() => runValidationTasks("FuelType", FuelType)}
        errorMessage={errors.FuelType?.errorMessage}
        hasError={errors.FuelType?.hasError}
        {...getOverrideProps(overrides, "FuelType")}
      >
        <option
          children="Gasoline"
          value="GASOLINE"
          {...getOverrideProps(overrides, "FuelTypeoption0")}
        ></option>
        <option
          children="Diesel"
          value="DIESEL"
          {...getOverrideProps(overrides, "FuelTypeoption1")}
        ></option>
        <option
          children="Electric"
          value="ELECTRIC"
          {...getOverrideProps(overrides, "FuelTypeoption2")}
        ></option>
        <option
          children="Hybrid"
          value="HYBRID"
          {...getOverrideProps(overrides, "FuelTypeoption3")}
        ></option>
        <option
          children="Coal"
          value="COAL"
          {...getOverrideProps(overrides, "FuelTypeoption4")}
        ></option>
        <option
          children="Jetfuel"
          value="JETFUEL"
          {...getOverrideProps(overrides, "FuelTypeoption5")}
        ></option>
        <option
          children="Other"
          value="OTHER"
          {...getOverrideProps(overrides, "FuelTypeoption6")}
        ></option>
      </SelectField>
      <SelectField
        label="Transmission"
        placeholder="Please select an option"
        isDisabled={false}
        value={Transmission}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission: value,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            value = result?.Transmission ?? value;
          }
          if (errors.Transmission?.hasError) {
            runValidationTasks("Transmission", value);
          }
          setTransmission(value);
        }}
        onBlur={() => runValidationTasks("Transmission", Transmission)}
        errorMessage={errors.Transmission?.errorMessage}
        hasError={errors.Transmission?.hasError}
        {...getOverrideProps(overrides, "Transmission")}
      >
        <option
          children="Manual"
          value="MANUAL"
          {...getOverrideProps(overrides, "Transmissionoption0")}
        ></option>
        <option
          children="Automatic"
          value="AUTOMATIC"
          {...getOverrideProps(overrides, "Transmissionoption1")}
        ></option>
        <option
          children="Cvt"
          value="CVT"
          {...getOverrideProps(overrides, "Transmissionoption2")}
        ></option>
        <option
          children="Semi automatic"
          value="SEMI_AUTOMATIC"
          {...getOverrideProps(overrides, "Transmissionoption3")}
        ></option>
        <option
          children="Other"
          value="OTHER"
          {...getOverrideProps(overrides, "Transmissionoption4")}
        ></option>
      </SelectField>
      <SelectField
        label="Drivetrain"
        placeholder="Please select an option"
        isDisabled={false}
        value={Drivetrain}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain: value,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            value = result?.Drivetrain ?? value;
          }
          if (errors.Drivetrain?.hasError) {
            runValidationTasks("Drivetrain", value);
          }
          setDrivetrain(value);
        }}
        onBlur={() => runValidationTasks("Drivetrain", Drivetrain)}
        errorMessage={errors.Drivetrain?.errorMessage}
        hasError={errors.Drivetrain?.hasError}
        {...getOverrideProps(overrides, "Drivetrain")}
      >
        <option
          children="Awd"
          value="AWD"
          {...getOverrideProps(overrides, "Drivetrainoption0")}
        ></option>
        <option
          children="Fwd"
          value="FWD"
          {...getOverrideProps(overrides, "Drivetrainoption1")}
        ></option>
        <option
          children="Rwd"
          value="RWD"
          {...getOverrideProps(overrides, "Drivetrainoption2")}
        ></option>
        <option
          children="Bwd"
          value="BWD"
          {...getOverrideProps(overrides, "Drivetrainoption3")}
        ></option>
        <option
          children="Other"
          value="OTHER"
          {...getOverrideProps(overrides, "Drivetrainoption4")}
        ></option>
      </SelectField>
      <TextField
        label="Acceleration"
        isRequired={false}
        isReadOnly={false}
        value={Acceleration}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration: value,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            value = result?.Acceleration ?? value;
          }
          if (errors.Acceleration?.hasError) {
            runValidationTasks("Acceleration", value);
          }
          setAcceleration(value);
        }}
        onBlur={() => runValidationTasks("Acceleration", Acceleration)}
        errorMessage={errors.Acceleration?.errorMessage}
        hasError={errors.Acceleration?.hasError}
        {...getOverrideProps(overrides, "Acceleration")}
      ></TextField>
      <TextField
        label="Top speed"
        isRequired={false}
        isReadOnly={false}
        value={TopSpeed}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed: value,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            value = result?.TopSpeed ?? value;
          }
          if (errors.TopSpeed?.hasError) {
            runValidationTasks("TopSpeed", value);
          }
          setTopSpeed(value);
        }}
        onBlur={() => runValidationTasks("TopSpeed", TopSpeed)}
        errorMessage={errors.TopSpeed?.errorMessage}
        hasError={errors.TopSpeed?.hasError}
        {...getOverrideProps(overrides, "TopSpeed")}
      ></TextField>
      <TextField
        label="Fuel economy"
        isRequired={false}
        isReadOnly={false}
        value={FuelEconomy}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy: value,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            value = result?.FuelEconomy ?? value;
          }
          if (errors.FuelEconomy?.hasError) {
            runValidationTasks("FuelEconomy", value);
          }
          setFuelEconomy(value);
        }}
        onBlur={() => runValidationTasks("FuelEconomy", FuelEconomy)}
        errorMessage={errors.FuelEconomy?.errorMessage}
        hasError={errors.FuelEconomy?.hasError}
        {...getOverrideProps(overrides, "FuelEconomy")}
      ></TextField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures: values,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            values = result?.InteriorFeatures ?? values;
          }
          setInteriorFeatures(values);
          setCurrentInteriorFeaturesValue("");
        }}
        currentFieldValue={currentInteriorFeaturesValue}
        label={"Interior features"}
        items={InteriorFeatures}
        hasError={errors?.InteriorFeatures?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks(
            "InteriorFeatures",
            currentInteriorFeaturesValue
          )
        }
        errorMessage={errors?.InteriorFeatures?.errorMessage}
        setFieldValue={setCurrentInteriorFeaturesValue}
        inputFieldRef={InteriorFeaturesRef}
        defaultFieldValue={""}
      >
        <TextField
          label="Interior features"
          isRequired={false}
          isReadOnly={false}
          value={currentInteriorFeaturesValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.InteriorFeatures?.hasError) {
              runValidationTasks("InteriorFeatures", value);
            }
            setCurrentInteriorFeaturesValue(value);
          }}
          onBlur={() =>
            runValidationTasks("InteriorFeatures", currentInteriorFeaturesValue)
          }
          errorMessage={errors.InteriorFeatures?.errorMessage}
          hasError={errors.InteriorFeatures?.hasError}
          ref={InteriorFeaturesRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "InteriorFeatures")}
        ></TextField>
      </ArrayField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures: values,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            values = result?.ExteriorFeatures ?? values;
          }
          setExteriorFeatures(values);
          setCurrentExteriorFeaturesValue("");
        }}
        currentFieldValue={currentExteriorFeaturesValue}
        label={"Exterior features"}
        items={ExteriorFeatures}
        hasError={errors?.ExteriorFeatures?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks(
            "ExteriorFeatures",
            currentExteriorFeaturesValue
          )
        }
        errorMessage={errors?.ExteriorFeatures?.errorMessage}
        setFieldValue={setCurrentExteriorFeaturesValue}
        inputFieldRef={ExteriorFeaturesRef}
        defaultFieldValue={""}
      >
        <TextField
          label="Exterior features"
          isRequired={false}
          isReadOnly={false}
          value={currentExteriorFeaturesValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.ExteriorFeatures?.hasError) {
              runValidationTasks("ExteriorFeatures", value);
            }
            setCurrentExteriorFeaturesValue(value);
          }}
          onBlur={() =>
            runValidationTasks("ExteriorFeatures", currentExteriorFeaturesValue)
          }
          errorMessage={errors.ExteriorFeatures?.errorMessage}
          hasError={errors.ExteriorFeatures?.hasError}
          ref={ExteriorFeaturesRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "ExteriorFeatures")}
        ></TextField>
      </ArrayField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures: values,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            values = result?.SafetyFeatures ?? values;
          }
          setSafetyFeatures(values);
          setCurrentSafetyFeaturesValue("");
        }}
        currentFieldValue={currentSafetyFeaturesValue}
        label={"Safety features"}
        items={SafetyFeatures}
        hasError={errors?.SafetyFeatures?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks("SafetyFeatures", currentSafetyFeaturesValue)
        }
        errorMessage={errors?.SafetyFeatures?.errorMessage}
        setFieldValue={setCurrentSafetyFeaturesValue}
        inputFieldRef={SafetyFeaturesRef}
        defaultFieldValue={""}
      >
        <TextField
          label="Safety features"
          isRequired={false}
          isReadOnly={false}
          value={currentSafetyFeaturesValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.SafetyFeatures?.hasError) {
              runValidationTasks("SafetyFeatures", value);
            }
            setCurrentSafetyFeaturesValue(value);
          }}
          onBlur={() =>
            runValidationTasks("SafetyFeatures", currentSafetyFeaturesValue)
          }
          errorMessage={errors.SafetyFeatures?.errorMessage}
          hasError={errors.SafetyFeatures?.hasError}
          ref={SafetyFeaturesRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "SafetyFeatures")}
        ></TextField>
      </ArrayField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures: values,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            values = result?.DriverAssistFeatures ?? values;
          }
          setDriverAssistFeatures(values);
          setCurrentDriverAssistFeaturesValue("");
        }}
        currentFieldValue={currentDriverAssistFeaturesValue}
        label={"Driver assist features"}
        items={DriverAssistFeatures}
        hasError={errors?.DriverAssistFeatures?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks(
            "DriverAssistFeatures",
            currentDriverAssistFeaturesValue
          )
        }
        errorMessage={errors?.DriverAssistFeatures?.errorMessage}
        setFieldValue={setCurrentDriverAssistFeaturesValue}
        inputFieldRef={DriverAssistFeaturesRef}
        defaultFieldValue={""}
      >
        <TextField
          label="Driver assist features"
          isRequired={false}
          isReadOnly={false}
          value={currentDriverAssistFeaturesValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.DriverAssistFeatures?.hasError) {
              runValidationTasks("DriverAssistFeatures", value);
            }
            setCurrentDriverAssistFeaturesValue(value);
          }}
          onBlur={() =>
            runValidationTasks(
              "DriverAssistFeatures",
              currentDriverAssistFeaturesValue
            )
          }
          errorMessage={errors.DriverAssistFeatures?.errorMessage}
          hasError={errors.DriverAssistFeatures?.hasError}
          ref={DriverAssistFeaturesRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "DriverAssistFeatures")}
        ></TextField>
      </ArrayField>
      <TextField
        label="Cargo space"
        isRequired={false}
        isReadOnly={false}
        value={CargoSpace}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace: value,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            value = result?.CargoSpace ?? value;
          }
          if (errors.CargoSpace?.hasError) {
            runValidationTasks("CargoSpace", value);
          }
          setCargoSpace(value);
        }}
        onBlur={() => runValidationTasks("CargoSpace", CargoSpace)}
        errorMessage={errors.CargoSpace?.errorMessage}
        hasError={errors.CargoSpace?.hasError}
        {...getOverrideProps(overrides, "CargoSpace")}
      ></TextField>
      <TextField
        label="Seating capacity"
        isRequired={true}
        isReadOnly={false}
        type="number"
        step="any"
        value={SeatingCapacity}
        onChange={(e) => {
          let value = isNaN(parseInt(e.target.value))
            ? e.target.value
            : parseInt(e.target.value);
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity: value,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            value = result?.SeatingCapacity ?? value;
          }
          if (errors.SeatingCapacity?.hasError) {
            runValidationTasks("SeatingCapacity", value);
          }
          setSeatingCapacity(value);
        }}
        onBlur={() => runValidationTasks("SeatingCapacity", SeatingCapacity)}
        errorMessage={errors.SeatingCapacity?.errorMessage}
        hasError={errors.SeatingCapacity?.hasError}
        {...getOverrideProps(overrides, "SeatingCapacity")}
      ></TextField>
      <TextField
        label="Tire size"
        isRequired={false}
        isReadOnly={false}
        value={TireSize}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize: value,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            value = result?.TireSize ?? value;
          }
          if (errors.TireSize?.hasError) {
            runValidationTasks("TireSize", value);
          }
          setTireSize(value);
        }}
        onBlur={() => runValidationTasks("TireSize", TireSize)}
        errorMessage={errors.TireSize?.errorMessage}
        hasError={errors.TireSize?.hasError}
        {...getOverrideProps(overrides, "TireSize")}
      ></TextField>
      <TextField
        label="Dimensions"
        isRequired={false}
        isReadOnly={false}
        value={Dimensions}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions: value,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            value = result?.Dimensions ?? value;
          }
          if (errors.Dimensions?.hasError) {
            runValidationTasks("Dimensions", value);
          }
          setDimensions(value);
        }}
        onBlur={() => runValidationTasks("Dimensions", Dimensions)}
        errorMessage={errors.Dimensions?.errorMessage}
        hasError={errors.Dimensions?.hasError}
        {...getOverrideProps(overrides, "Dimensions")}
      ></TextField>
      <TextField
        label="Wheelbase"
        isRequired={false}
        isReadOnly={false}
        value={Wheelbase}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase: value,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            value = result?.Wheelbase ?? value;
          }
          if (errors.Wheelbase?.hasError) {
            runValidationTasks("Wheelbase", value);
          }
          setWheelbase(value);
        }}
        onBlur={() => runValidationTasks("Wheelbase", Wheelbase)}
        errorMessage={errors.Wheelbase?.errorMessage}
        hasError={errors.Wheelbase?.hasError}
        {...getOverrideProps(overrides, "Wheelbase")}
      ></TextField>
      <TextField
        label="Weight"
        isRequired={false}
        isReadOnly={false}
        value={Weight}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight: value,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            value = result?.Weight ?? value;
          }
          if (errors.Weight?.hasError) {
            runValidationTasks("Weight", value);
          }
          setWeight(value);
        }}
        onBlur={() => runValidationTasks("Weight", Weight)}
        errorMessage={errors.Weight?.errorMessage}
        hasError={errors.Weight?.hasError}
        {...getOverrideProps(overrides, "Weight")}
      ></TextField>
      <TextField
        label="Suspension type"
        isRequired={false}
        isReadOnly={false}
        value={SuspensionType}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType: value,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            value = result?.SuspensionType ?? value;
          }
          if (errors.SuspensionType?.hasError) {
            runValidationTasks("SuspensionType", value);
          }
          setSuspensionType(value);
        }}
        onBlur={() => runValidationTasks("SuspensionType", SuspensionType)}
        errorMessage={errors.SuspensionType?.errorMessage}
        hasError={errors.SuspensionType?.hasError}
        {...getOverrideProps(overrides, "SuspensionType")}
      ></TextField>
      <TextField
        label="Braking system"
        isRequired={false}
        isReadOnly={false}
        value={BrakingSystem}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem: value,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            value = result?.BrakingSystem ?? value;
          }
          if (errors.BrakingSystem?.hasError) {
            runValidationTasks("BrakingSystem", value);
          }
          setBrakingSystem(value);
        }}
        onBlur={() => runValidationTasks("BrakingSystem", BrakingSystem)}
        errorMessage={errors.BrakingSystem?.errorMessage}
        hasError={errors.BrakingSystem?.hasError}
        {...getOverrideProps(overrides, "BrakingSystem")}
      ></TextField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions: values,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            values = result?.ColorOptions ?? values;
          }
          setColorOptions(values);
          setCurrentColorOptionsValue("");
        }}
        currentFieldValue={currentColorOptionsValue}
        label={"Color options"}
        items={ColorOptions}
        hasError={errors?.ColorOptions?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks("ColorOptions", currentColorOptionsValue)
        }
        errorMessage={errors?.ColorOptions?.errorMessage}
        setFieldValue={setCurrentColorOptionsValue}
        inputFieldRef={ColorOptionsRef}
        defaultFieldValue={""}
      >
        <TextField
          label="Color options"
          isRequired={false}
          isReadOnly={false}
          value={currentColorOptionsValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.ColorOptions?.hasError) {
              runValidationTasks("ColorOptions", value);
            }
            setCurrentColorOptionsValue(value);
          }}
          onBlur={() =>
            runValidationTasks("ColorOptions", currentColorOptionsValue)
          }
          errorMessage={errors.ColorOptions?.errorMessage}
          hasError={errors.ColorOptions?.hasError}
          ref={ColorOptionsRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "ColorOptions")}
        ></TextField>
      </ArrayField>
      <TextField
        label="Price"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={Price}
        onChange={(e) => {
          let value = isNaN(parseFloat(e.target.value))
            ? e.target.value
            : parseFloat(e.target.value);
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price: value,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            value = result?.Price ?? value;
          }
          if (errors.Price?.hasError) {
            runValidationTasks("Price", value);
          }
          setPrice(value);
        }}
        onBlur={() => runValidationTasks("Price", Price)}
        errorMessage={errors.Price?.errorMessage}
        hasError={errors.Price?.hasError}
        {...getOverrideProps(overrides, "Price")}
      ></TextField>
      <TextField
        label="Warranty"
        isRequired={false}
        isReadOnly={false}
        value={Warranty}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty: value,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            value = result?.Warranty ?? value;
          }
          if (errors.Warranty?.hasError) {
            runValidationTasks("Warranty", value);
          }
          setWarranty(value);
        }}
        onBlur={() => runValidationTasks("Warranty", Warranty)}
        errorMessage={errors.Warranty?.errorMessage}
        hasError={errors.Warranty?.hasError}
        {...getOverrideProps(overrides, "Warranty")}
      ></TextField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem: values,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            values = result?.EntertainmentSystem ?? values;
          }
          setEntertainmentSystem(values);
          setCurrentEntertainmentSystemValue("");
        }}
        currentFieldValue={currentEntertainmentSystemValue}
        label={"Entertainment system"}
        items={EntertainmentSystem}
        hasError={errors?.EntertainmentSystem?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks(
            "EntertainmentSystem",
            currentEntertainmentSystemValue
          )
        }
        errorMessage={errors?.EntertainmentSystem?.errorMessage}
        setFieldValue={setCurrentEntertainmentSystemValue}
        inputFieldRef={EntertainmentSystemRef}
        defaultFieldValue={""}
      >
        <TextField
          label="Entertainment system"
          isRequired={false}
          isReadOnly={false}
          value={currentEntertainmentSystemValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.EntertainmentSystem?.hasError) {
              runValidationTasks("EntertainmentSystem", value);
            }
            setCurrentEntertainmentSystemValue(value);
          }}
          onBlur={() =>
            runValidationTasks(
              "EntertainmentSystem",
              currentEntertainmentSystemValue
            )
          }
          errorMessage={errors.EntertainmentSystem?.errorMessage}
          hasError={errors.EntertainmentSystem?.hasError}
          ref={EntertainmentSystemRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "EntertainmentSystem")}
        ></TextField>
      </ArrayField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures: values,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            values = result?.ConnectivityFeatures ?? values;
          }
          setConnectivityFeatures(values);
          setCurrentConnectivityFeaturesValue("");
        }}
        currentFieldValue={currentConnectivityFeaturesValue}
        label={"Connectivity features"}
        items={ConnectivityFeatures}
        hasError={errors?.ConnectivityFeatures?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks(
            "ConnectivityFeatures",
            currentConnectivityFeaturesValue
          )
        }
        errorMessage={errors?.ConnectivityFeatures?.errorMessage}
        setFieldValue={setCurrentConnectivityFeaturesValue}
        inputFieldRef={ConnectivityFeaturesRef}
        defaultFieldValue={""}
      >
        <TextField
          label="Connectivity features"
          isRequired={false}
          isReadOnly={false}
          value={currentConnectivityFeaturesValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.ConnectivityFeatures?.hasError) {
              runValidationTasks("ConnectivityFeatures", value);
            }
            setCurrentConnectivityFeaturesValue(value);
          }}
          onBlur={() =>
            runValidationTasks(
              "ConnectivityFeatures",
              currentConnectivityFeaturesValue
            )
          }
          errorMessage={errors.ConnectivityFeatures?.errorMessage}
          hasError={errors.ConnectivityFeatures?.hasError}
          ref={ConnectivityFeaturesRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "ConnectivityFeatures")}
        ></TextField>
      </ArrayField>
      <TextField
        label="Aerodynamics"
        isRequired={false}
        isReadOnly={false}
        value={Aerodynamics}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics: value,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            value = result?.Aerodynamics ?? value;
          }
          if (errors.Aerodynamics?.hasError) {
            runValidationTasks("Aerodynamics", value);
          }
          setAerodynamics(value);
        }}
        onBlur={() => runValidationTasks("Aerodynamics", Aerodynamics)}
        errorMessage={errors.Aerodynamics?.errorMessage}
        hasError={errors.Aerodynamics?.hasError}
        {...getOverrideProps(overrides, "Aerodynamics")}
      ></TextField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages: values,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            values = result?.PerformancePackages ?? values;
          }
          setPerformancePackages(values);
          setCurrentPerformancePackagesValue("");
        }}
        currentFieldValue={currentPerformancePackagesValue}
        label={"Performance packages"}
        items={PerformancePackages}
        hasError={errors?.PerformancePackages?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks(
            "PerformancePackages",
            currentPerformancePackagesValue
          )
        }
        errorMessage={errors?.PerformancePackages?.errorMessage}
        setFieldValue={setCurrentPerformancePackagesValue}
        inputFieldRef={PerformancePackagesRef}
        defaultFieldValue={""}
      >
        <TextField
          label="Performance packages"
          isRequired={false}
          isReadOnly={false}
          value={currentPerformancePackagesValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.PerformancePackages?.hasError) {
              runValidationTasks("PerformancePackages", value);
            }
            setCurrentPerformancePackagesValue(value);
          }}
          onBlur={() =>
            runValidationTasks(
              "PerformancePackages",
              currentPerformancePackagesValue
            )
          }
          errorMessage={errors.PerformancePackages?.errorMessage}
          hasError={errors.PerformancePackages?.hasError}
          ref={PerformancePackagesRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "PerformancePackages")}
        ></TextField>
      </ArrayField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications: values,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            values = result?.Certifications ?? values;
          }
          setCertifications(values);
          setCurrentCertificationsValue("");
        }}
        currentFieldValue={currentCertificationsValue}
        label={"Certifications"}
        items={Certifications}
        hasError={errors?.Certifications?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks("Certifications", currentCertificationsValue)
        }
        errorMessage={errors?.Certifications?.errorMessage}
        setFieldValue={setCurrentCertificationsValue}
        inputFieldRef={CertificationsRef}
        defaultFieldValue={""}
      >
        <TextField
          label="Certifications"
          isRequired={false}
          isReadOnly={false}
          value={currentCertificationsValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.Certifications?.hasError) {
              runValidationTasks("Certifications", value);
            }
            setCurrentCertificationsValue(value);
          }}
          onBlur={() =>
            runValidationTasks("Certifications", currentCertificationsValue)
          }
          errorMessage={errors.Certifications?.errorMessage}
          hasError={errors.Certifications?.hasError}
          ref={CertificationsRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "Certifications")}
        ></TextField>
      </ArrayField>
      <TextField
        label="Country of origin"
        isRequired={false}
        isReadOnly={false}
        value={CountryOfOrigin}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin: value,
              CompetingModels,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            value = result?.CountryOfOrigin ?? value;
          }
          if (errors.CountryOfOrigin?.hasError) {
            runValidationTasks("CountryOfOrigin", value);
          }
          setCountryOfOrigin(value);
        }}
        onBlur={() => runValidationTasks("CountryOfOrigin", CountryOfOrigin)}
        errorMessage={errors.CountryOfOrigin?.errorMessage}
        hasError={errors.CountryOfOrigin?.hasError}
        {...getOverrideProps(overrides, "CountryOfOrigin")}
      ></TextField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels: values,
              Information,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            values = result?.CompetingModels ?? values;
          }
          setCompetingModels(values);
          setCurrentCompetingModelsValue("");
        }}
        currentFieldValue={currentCompetingModelsValue}
        label={"Competing models"}
        items={CompetingModels}
        hasError={errors?.CompetingModels?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks(
            "CompetingModels",
            currentCompetingModelsValue
          )
        }
        errorMessage={errors?.CompetingModels?.errorMessage}
        setFieldValue={setCurrentCompetingModelsValue}
        inputFieldRef={CompetingModelsRef}
        defaultFieldValue={""}
      >
        <TextField
          label="Competing models"
          isRequired={false}
          isReadOnly={false}
          value={currentCompetingModelsValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.CompetingModels?.hasError) {
              runValidationTasks("CompetingModels", value);
            }
            setCurrentCompetingModelsValue(value);
          }}
          onBlur={() =>
            runValidationTasks("CompetingModels", currentCompetingModelsValue)
          }
          errorMessage={errors.CompetingModels?.errorMessage}
          hasError={errors.CompetingModels?.hasError}
          ref={CompetingModelsRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "CompetingModels")}
        ></TextField>
      </ArrayField>
      <TextField
        label="Information"
        isRequired={false}
        isReadOnly={false}
        value={Information}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information: value,
              Picture,
              Make,
            };
            const result = onChange(modelFields);
            value = result?.Information ?? value;
          }
          if (errors.Information?.hasError) {
            runValidationTasks("Information", value);
          }
          setInformation(value);
        }}
        onBlur={() => runValidationTasks("Information", Information)}
        errorMessage={errors.Information?.errorMessage}
        hasError={errors.Information?.hasError}
        {...getOverrideProps(overrides, "Information")}
      ></TextField>
      <TextField
        label="Picture"
        isRequired={false}
        isReadOnly={false}
        value={Picture}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture: value,
              Make,
            };
            const result = onChange(modelFields);
            value = result?.Picture ?? value;
          }
          if (errors.Picture?.hasError) {
            runValidationTasks("Picture", value);
          }
          setPicture(value);
        }}
        onBlur={() => runValidationTasks("Picture", Picture)}
        errorMessage={errors.Picture?.errorMessage}
        hasError={errors.Picture?.hasError}
        {...getOverrideProps(overrides, "Picture")}
      ></TextField>
      <TextField
        label="Label"
        value={Make}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Manufacturer,
              ModelName,
              ModelYear,
              VehicleType,
              BodyStyle,
              EngineType,
              EnginePower,
              FuelType,
              Transmission,
              Drivetrain,
              Acceleration,
              TopSpeed,
              FuelEconomy,
              InteriorFeatures,
              ExteriorFeatures,
              SafetyFeatures,
              DriverAssistFeatures,
              CargoSpace,
              SeatingCapacity,
              TireSize,
              Dimensions,
              Wheelbase,
              Weight,
              SuspensionType,
              BrakingSystem,
              ColorOptions,
              Price,
              Warranty,
              EntertainmentSystem,
              ConnectivityFeatures,
              Aerodynamics,
              PerformancePackages,
              Certifications,
              CountryOfOrigin,
              CompetingModels,
              Information,
              Picture,
              Make: value,
            };
            const result = onChange(modelFields);
            value = result?.Make ?? value;
          }
          if (errors.Make?.hasError) {
            runValidationTasks("Make", value);
          }
          setMake(value);
        }}
        onBlur={() => runValidationTasks("Make", Make)}
        errorMessage={errors.Make?.errorMessage}
        hasError={errors.Make?.hasError}
        {...getOverrideProps(overrides, "Make")}
      ></TextField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
